module.exports = __webpack_public_path__ + "assets/webgl/skybox.jpg.astc.84b456f0.ktx";